import React from 'react';
import { Table, Header, Segment, Button, Container, Form, Checkbox, Menu, Popup } from 'semantic-ui-react';
import { PageHeader } from 'react-bootstrap';
import Modal from 'react-modal';
import moment from 'moment';
import { HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import axios from 'axios';
import { Link, NavLink, Redirect, Route, withRouter } from 'react-router-dom';
import { lookupConfig } from './lookupConfig';
import LookupSimpler from './LookupSimpler';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;O


class Lookups extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const { location } = this.props;
        const currentPath = location.pathname;
        console.log(currentPath);
        return (

            <div>
                <Header as="h1">Šifrarnici</Header>
                {currentPath === '/šifrarnici' && <Segment.Group raised>

                    <Segment>
                        <h3>Pregled svih šifrarnika</h3>
                    </Segment>

                    <Segment>
                        <Table celled selectable>
                            <Table.Header>

                                <Table.Row>
                                    <Table.HeaderCell>Naziv</Table.HeaderCell>
                                    <Table.HeaderCell />
                                </Table.Row>


                            </Table.Header>
                            <Table.Body>
                                {lookupConfig.map((row, index) => (


                                    <Table.Row key={row.tableName} >

                                        <Table.Cell verticalAlign="middle">
                                            {/* <Menu.Item */}
                                            {/*     as={NavLink} */}
                                            {/*     to={'/šifrarnici/' + row.frontEndPath} */}
                                            {/*     content={row.tableSimpleName} */}
                                            {/* /> */}
                                            {row.tableSimpleName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                            <Link to={{ pathname: '/šifrarnici/' + row.frontEndPath }}>
                                                <Popup
                                                    content="Pregled podataka"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="blue"
                                                            circular
                                                            icon="bars"
                                                            size="small"

                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>

                                        </Table.Cell>

                                    </Table.Row>

                                ))}
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>}


                {/* za rute, jer je HOC */}
                {lookupConfig.map((configObj, index) =>
                    (<Route
                        exact
                        key={index}
                        path={'/šifrarnici/' + configObj.frontEndPath}
                        render={(props) => <LookupSimpler config={configObj} {...props} />}
                    />))
                }


                {/* {currentPath === '/šifrarnici' && <Menu.Menu style={{ marginLeft: '7px' }}> */}
                {/*     {lookupConfig.map((config, index) => ( */}
                {/*         <Menu.Item */}
                {/*             as={NavLink} */}
                {/*             to={'/šifrarnici/' + config.frontEndPath} */}
                {/*             content={config.tableSimpleName} */}
                {/*         /> */}
                {/*     ))} */}
                {/* </Menu.Menu>} */}
            </div>
        );
    }
}

export default Lookups;



// WEBPACK FOOTER //
// ./src/views/Lookups/Lookups.js